import React from 'react';
import { connect } from "react-redux";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import AppLocale from "../../config/lang";
import _axios from '../../libs/axios';
import { NotificationManager } from '../common/react-notifications';
import PerfectScrollbar from 'react-perfect-scrollbar';

class CustomDropdown extends React.Component {
  constructor(props) {
    super(props)
    // console.log(props)
    this.toggle = this.toggle.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {
      items: props.items ?? [],
      dropdownOpen: false,
      selected: props.selected ?? null,
      loadingTxt: null
    }
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }), () => {
      if (this.state.dropdownOpen) {
        if(this.state.items.length === 0) this.getItems()
      }
    })
  }

  getItems() {
    this.setState({ loadingTxt: "main.loading" })
    _axios
      .get(this.props.resourceUrl)
      .then(r => {
        if (r.status >= 0) {
          const items = (r.data.Results || []).map(item => item = {id: item.ID, name: item.name})
          const fallbackItems = this.props.fallbackItems ?? []
          const alwaysShowFallbackItems = this.props.alwaysShowFallbackItems ?? false
          let itemsToSet = items.length === 0 && fallbackItems.length > 0 ? fallbackItems : items
          if (alwaysShowFallbackItems && fallbackItems.length > 0) {
            const fallbackIds = new Set(fallbackItems.map(item => `${item.id}`))
            const normalizedItems = items.filter(item => !fallbackIds.has(`${item.id}`))
            itemsToSet = [...fallbackItems, ...normalizedItems]
          }
          this.setState({items: itemsToSet})
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.setState({ loadingTxt: null })
      })
  }

  onMouseEnter() {
    this.setState({dropdownOpen: true})
  }

  onMouseLeave() {
    this.setState({dropdownOpen: false})
  }

  handleOnClick(item) {
    const { rowData, ctx, listenBtnActions, onChange } = this.props
    this.setState({selected: item?.id}, () => {
      if (onChange) onChange(item)
    })
    if (item.onClick) item.onClick(rowData, ctx, item.id)
    if (listenBtnActions) listenBtnActions('menu', item, rowData)
  }
  
  render() {
    const isMobile = window.innerWidth <= 500
    const { locale, label, icon, addCheck, style, direction, rowData, showMenuOnHover, showItemSelected, size } = this.props
    const { items, dropdownOpen, selected, loadingTxt } = this.state
    const L = AppLocale[locale].messages
    const hasLabelToggle = label !== null && label !== undefined
    const selectedItem = typeof selected === "object" && selected !== null
      ? selected
      : items.find(item => item.id === selected)
    const selectedLabel = showItemSelected && selectedItem ? (L[selectedItem.name] ?? selectedItem.name) : (L[label] ?? label)
    const hasVisibleText = `${selectedLabel ?? ""}`.trim().length > 0
    return (
      <Dropdown
        direction={direction?? "left"}
        className="dropdown-menu-up"
        style={style?? {position: 'static'}}
        onMouseOver={(!isMobile && showMenuOnHover) ? this.onMouseEnter : null}
        onMouseLeave={(!isMobile && showMenuOnHover) ? this.onMouseLeave : null}
        isOpen={dropdownOpen}
        toggle={this.toggle}
      >
        {icon && <DropdownToggle className="p-0 d-flex align-items-center" color="empty">
          <i className={`${icon} icon-action`}/>
        </DropdownToggle>}
        {hasLabelToggle && <DropdownToggle
          size={size ?? "xs"}
          color="primary"
          outline
          className={`d-flex align-items-center ${hasVisibleText ? "justify-content-between" : "justify-content-center"}`}
        >
          {hasVisibleText && <span className="text-left">{selectedLabel}</span>}
          <i className={`simple-icon-arrow-down ${hasVisibleText ? "ml-2" : ""}`} />
        </DropdownToggle>}
        <DropdownMenu className="m-0 custom-dropdown" style={{
          ...(items?.length >= 7 ? {height: "264px"} : {maxHeight: "200px"}),
          ...({minWidth: "3rem"})
        }}>
          {loadingTxt && <DropdownItem>{`${L[loadingTxt]}`}</DropdownItem>}
          <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false }}>
            {items.map((item, index) => {
              return (
                <DropdownItem onClick={() => { this.handleOnClick(item) } } key={index}>
                  <div className="flex ai-c">
                    {(addCheck || item.icon) && <div style={{width: '18px'}} className="flex ai-c pr-2">
                      {item.id === selectedItem?.id && addCheck && <i className="simple-icon-check"></i>}
                      {item.icon && <i className={item.icon}></i>} 
                    </div>}
                    <div>{typeof item.name == "function" ? item.name(rowData) : L[item.name] ?? item.name}</div>
                  </div>
                </DropdownItem>
              )
            })}
          </PerfectScrollbar>
        </DropdownMenu>
      </Dropdown>
    )
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale }
}

export default connect(mapStateToProps)(CustomDropdown)